import React from 'react';

import { Box, Center, HStack } from '@chakra-ui/react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { customTheme } from 'theme';

import { ExclamationTriangleIcon } from 'components/Icons';

// Fixed: register the utc plugin here; .local() crashed unless another module
// had already loaded it.
dayjs.extend(utc);

export const renderExceptionExpiresOn = (expiresOn: string) => {
  return (
    <HStack>
      <Box boxSize={5} color="critical">
        <Center>
          <ExclamationTriangleIcon />
        </Center>
      </Box>
      <Box color={customTheme.colors.gray['250']}>
        Expires on {dayjs(expiresOn).local().format('DD-MMM-YY hh:mm A')}
      </Box>
    </HStack>
  );
};
